import React, { memo } from 'react';
import { getTime, addDays, subDays } from 'date-fns';
import {
	getBarLeftPosition,
	getBarRightPosition,
} from '@atlassian/jira-software-roadmap-timeline-table-kit/src/common/utils/bar/positions.tsx';
import { DEFAULT_ITEM_HEIGHT } from '@atlassian/jira-software-roadmap-timeline-table/src/common/constants.tsx';
import { useTimelineState } from '@atlassian/jira-software-roadmap-timeline-table/src/common/context/timeline/index.tsx';
import { LoadingBar } from '../../../common/ui/loading/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ChartItemContentSkeleton = memo<Record<any, any>>(() => {
	const [{ timelineDuration, timelineWidth }] = useTimelineState();

	const today = Date.now();
	const startDate = getTime(subDays(today, Math.floor(Math.random() * 10) + 1));
	const dueDate = getTime(addDays(today, Math.floor(Math.random() * 10) + 30));

	const leftPosition = getBarLeftPosition(startDate, timelineDuration, timelineWidth);
	const rightPosition = getBarRightPosition(dueDate, timelineDuration, timelineWidth);

	return (
		<LoadingBar
			leftPosition={leftPosition}
			rightPosition={rightPosition}
			itemHeight={DEFAULT_ITEM_HEIGHT}
		/>
	);
});
